import type { InputFieldOptions } from '@shared/flow/enrollment';

/**
 * U5 — a warm_intro_id-persisting input option means this item sends via a
 * connector's own multithread request rather than a direct Terra email.
 * Extracted (cleanup item c, rail-glaze-parity QA round) out of three
 * independent copies of the same `.find()`/`.some()` (`LeadRow.tsx`,
 * `LeadExpandedBody.tsx`, `EnrollmentItemEditor.tsx`) so the row, its
 * expanded body, and the editor can never re-derive this differently (D30).
 *
 * Returns the FIELD itself (not a boolean) — `EnrollmentItemEditor.tsx`
 * needs the match for its own subject/body prefill derivation
 * (`selectedConnectorOption`); `LeadRow`/`LeadExpandedBody` only need a
 * boolean, which is just `!!findConnectorField(inputOptions)`.
 */
export function findConnectorField(inputOptions: InputFieldOptions[] | undefined): InputFieldOptions | undefined {
  return (inputOptions ?? []).find(field => field.persistsTo === 'warm_intro_id');
}
